"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DfnsDelegatedApiClient = void 0;
const Assets_1 = require("./codegen/Assets");
const Auth_1 = require("./codegen/Auth");
const Blockchains_1 = require("./codegen/Blockchains");
const Callbacks_1 = require("./codegen/Callbacks");
const Permissions_1 = require("./codegen/Permissions");
const PolicyExecution_1 = require("./codegen/PolicyExecution");
const PolicyManagement_1 = require("./codegen/PolicyManagement");
const PublicKeys_1 = require("./codegen/PublicKeys");
const Wallets_1 = require("./codegen/Wallets");
class DfnsDelegatedApiClient {
    constructor(apiOptions) {
        this.apiOptions = apiOptions;
    }
    get assets() {
        return new Assets_1.DelegatedAssetsClient(this.apiOptions);
    }
    get auth() {
        return new Auth_1.DelegatedAuthClient(this.apiOptions);
    }
    get blockchains() {
        return new Blockchains_1.DelegatedBlockchainsClient(this.apiOptions);
    }
    get callbacks() {
        return new Callbacks_1.DelegatedCallbacksClient(this.apiOptions);
    }
    get permissions() {
        return new Permissions_1.DelegatedPermissionsClient(this.apiOptions);
    }
    get policyExecution() {
        return new PolicyExecution_1.DelegatedPolicyExecutionClient(this.apiOptions);
    }
    get policyManagement() {
        return new PolicyManagement_1.DelegatedPolicyManagementClient(this.apiOptions);
    }
    get publicKeys() {
        return new PublicKeys_1.DelegatedPublicKeysClient(this.apiOptions);
    }
    get wallets() {
        return new Wallets_1.DelegatedWalletsClient(this.apiOptions);
    }
}
exports.DfnsDelegatedApiClient = DfnsDelegatedApiClient;
